import React, { useState, useEffect } from 'react';
import RemoveLastDirectoryPartOf from '../goBackButton';
import { useAPI } from '../../ApiCalls/useAPI';
import MoonLoader from 'react-spinners/MoonLoader';

const Rules = () => {
    const [rules, setRules] = useState('');

    useEffect(() => {
        const { getRules } = useAPI();
        getRules()
            .then((response) => {
                setRules(response);
            })
            .catch((error) => console.error(error));
    }, []);

    const override = `
        display: block;
        margin: 10% auto;
        border-color: red;
    `;
    if (rules === null) {
        return (
            <div>
                <h1 className="mt-4" style={{ textAlign: 'center' }}>
                    Waiting for data ...
                </h1>
                <MoonLoader
                    color={'green'}
                    isLoading={true}
                    css={override}
                    size={60}
                />
            </div>
        );
    } else {
        var data = rules.replace(/(<style[\w\W]+style>)/g, '');
        var data2 = data.replace(
            /(<ion-header-bar[\w\W]+ion-header-bar>)/g,
            ''
        );
        var data3 = data2.replaceAll('ion-pane', 'div');
        var data4 = data3.replaceAll('ion-content', 'div');
        var content = data4.replaceAll('ion-scroll', 'div');
        return (
            <div className="container">
                <div
                    className="m-2"
                    style={{ fontSize: '20px', display: 'flex' }}
                >
                    <div className="mr-4">
                        <a
                            href={RemoveLastDirectoryPartOf(
                                window.location.href
                            )}
                            style={{ textDecoration: 'none' }}
                        >
                            <i className="fe fe-arrow-left" />
                        </a>
                    </div>
                    <div>Rules and Regulations</div>
                </div>
                <div
                    className="container"
                    dangerouslySetInnerHTML={{ __html: content }}
                />
            </div>
        );
    }
};

export default Rules;
